import React, { FunctionComponent, useCallback, useMemo } from 'react';
import { AdminApi, AdminOrganization } from 'api';
import useApiCall from 'hooks/use-api-call';
import Translate from 'ui/atoms/translate';
import { Modal, ModalHeader, ModalContent, ModalFooter, ModalFooterButtons } from 'ui/molecules/modal';

interface DeleteOrganizationConfirmationModalProps {
  onDeleteOrganization: () => void;
  onClose: () => void;
  data: AdminOrganization;
}

const DeleteOrganizationConfirmationModal: FunctionComponent<DeleteOrganizationConfirmationModalProps> = ({
  onDeleteOrganization,
  onClose,
  data,
}) => {
  const { makeAuthenticatedApi, withApi } = useApiCall();

  const api: AdminApi = useMemo(() => makeAuthenticatedApi(AdminApi), [makeAuthenticatedApi]);

  const onSubmit = useCallback(() => {
    withApi(async () => {
      await api.adminOrganizationsDestroy({ id: data?.id! });

      onDeleteOrganization();
    });
  }, [data.id]);

  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name="confirmDeleteOrganizationModal.title" />
      </ModalHeader>
      <ModalContent>
        <Translate name="confirmDeleteOrganizationModal.content" args={[<strong>{data?.name}</strong>]} />
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'cancel',
              content: <Translate name="common.cancel" />,
              size: 'large',
              onClick: () => onClose(),
            },
            {
              name: 'delete',
              content: <Translate name="common.delete" />,
              onClick: () => onSubmit(),
              variant: 'primary',
              type: 'submit',
              size: 'large',
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default DeleteOrganizationConfirmationModal;
